import React, { useEffect, useState } from "react";
import Navbar from "./components/navbar/Navbar.js";
import Hero from "./components/hero/Hero";
import ProductPanel from "./components/product-panel/ProductPanel.js";
import ProductModal from "./components/product-modal/ProductModal.js";
import InfoModal from "./components/info-modal/InfoModal.js";
import Footer from "./components/footer/Footer.js";
// import Gallery from './components/Gallery/Gallery.js';

import "./App.css";
import "bulma/css/bulma.min.css";
import "@fortawesome/fontawesome-free/css/all.css";

import axios from "axios";

import PRODUCT_DATA from "./data/Products.js";
import HERO_DATA from "./data/Hero.js";
import APP_DATA from "./data/App.js";
import Gallery from "./components/Gallery/Gallery.js";
// import FAQ_DATA from './data/FAQ.js';

const ax = axios.create({
  baseURL: APP_DATA.baseUrl,
});

const wlsAx = axios.create({
  baseURL: APP_DATA.whitelistUrl,
});

function App() {
  const [infoModalActive, setInfoModalActive] = useState(false);
  const [productModalActive, setProductModalActive] = useState(false);
  const [hasLaunched, setHasLaunched] = useState(
    new Date(APP_DATA.launchDate) - new Date() <= 0
  );
  const [products] = useState(PRODUCT_DATA);
  const [activeProduct, setActiveProduct] = useState(PRODUCT_DATA[0]);
  const [reservedTimer, setReservedTimer] = useState(null);
  const [queueTimer, setQueueTimer] = useState(null);
  const [captchaUserResponsetoken, setCaptchaUserResponseToken] =
    useState(null);
  const [productStats, setProductStats] = useState(null);
  const [appStats, setAppStats] = useState({});

  useEffect(() => {
    document.title = APP_DATA.title;
  }, []);

  useEffect(() => {
    async function getStats() {
      let res;
      let res2;
      try {
        res = await ax.get("/stats");

        setProductStats(res.data);

        if (APP_DATA.useWhitelist) {
          res2 = await wlsAx.get(`/whitelist/${APP_DATA.whitelistId}/status`);
          setAppStats({ ...appStats, whitelist: res2.data });
        }
      } catch (e) {
        console.warn("Unable to load Stats", e);
        setProductStats(null);
      }
    }

    getStats();
    // eslint-disable-next-line
  }, []);

  const [reservationStatus, setReservationStatus] = useState(null);

  useEffect(() => {
    async function fetchReservation() {
      console.log(activeProduct);
      let res;
      try {
        res = await ax.get(`/reserve/${activeProduct.type}`, {
          params: { captchaToken: captchaUserResponsetoken },
        });
      } catch (error) {
        setReservationStatus("SERVER_ERROR");
        return;
      }
      console.log(res.data);
      let error_code = res.data.payload.error_code || null;
      //error_code "1" means too many tokens requested in a short time
      if (error_code === 1) {
        setActiveProduct((p) => ({ ...p, data: res.data }));
        setReservationStatus("COOLDOWN");
        return;
      }

      //error_code "2" means all tokens are sold out or reserved
      if (error_code === 2) {
        //TODO: handle case of all reserved or sold
        setReservationStatus("SOLD_OUT");
        return;
      }

      if (error_code === 5) {
        //TODO: handle case of all reserved or sold
        console.warn("Unable to confirm humanity");
        setReservationStatus("SERVER_ERROR");
        return;
      }

      //if state is queue, set state to queued
      //if state is reserved, do what we'd normally do
      const reservationState = res.data.payload.state;
      if (reservationState === "queued") {
        console.log("SET STATUS TO RESREVED (TODO)");
        setActiveProduct((p) => ({ ...p, data: res.data }));
        setQueueTimer(res.data.payload.queue_timer);
        setReservationStatus("QUEUED");
      } else if (reservationState === "reserved") {
        setActiveProduct((p) => ({ ...p, data: res.data }));
        setReservedTimer(res.data.payload.timer);
        setReservationStatus("RESERVED");
      } else {
        console.error(
          `UNRECOGNIZED STATE ${reservationState}. Has /reserve changed?`
        );
      }
    }

    async function fetchStatus() {
      const { key, reserve_hash } = activeProduct.data.payload;
      let res;
      try {
        res = await ax.get(`/status/${key}/${reserve_hash}`);
      } catch (error) {
        setReservationStatus("SERVER_ERROR");
        return;
      }

      if (res.data.status) {
        //handle transaction successful
        setActiveProduct((p) => ({ ...p, data: res.data }));
        setReservationStatus("SUCCESS");
      } else {
        //check if error === 3, thats status code for expired
        if (res.data.payload.error === 3) {
          setReservationStatus("EXPIRED");
          return;
        }

        if (res.data.payload.error === 14) {
          setReservationStatus("SERVER_ERROR");
          return;
        }

        console.log("status data:", res.data);
        const reservationState = res.data.payload.state;
        if (reservationState === "queued") {
          setQueueTimer(res.data.payload.queue_timer);
        } else if (reservationState === "reserved") {
          setReservedTimer(res.data.payload.timer);
          setActiveProduct((p) => ({ ...p, data: res.data }));
          setReservationStatus("RESERVED");
        } else {
          console.error(
            `UNRECOGNIZED STATE ${reservationState}. Has /status changed?`
          );
        }
      }
    }

    let statusIntervalId = null;
    switch (reservationStatus) {
      case "LOADING":
        fetchReservation();
        break;
      case "RESERVED":
      case "QUEUED":
        statusIntervalId = setInterval(fetchStatus, 10000);
        break;
      default:
        break;
    }
    return () => {
      clearInterval(statusIntervalId); //TODO: is this clearing as intended?
    };
    //deps not listed in array below are fine because we're relying on reservation state
    //comment below removes linter warning
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationStatus]);

  const reserveProduct = (product) => {
    setReservationStatus("LOADING");
  };

  const checkHumanity = (product) => {
    setActiveProduct(product);
    toggleProductModal();

    if (APP_DATA.useWhitelist === true && appStats.whitelist) {
      if (appStats.whitelist.status === "active") {
        setReservationStatus("WHITELIST");
        return;
      } else if (appStats.whitelist.status === "inactive") {
        setReservationStatus("CAPTCHA");
        return;
      } else {
        setReservationStatus("SERVER_ERROR");
      }
    } else if (APP_DATA.useWhitelist === false) {
      setReservationStatus("CAPTCHA");
    } else {
      setReservationStatus("SERVER_ERROR");
    }
  };

  const expireReservation = () => {
    setReservationStatus("EXPIRED");
  };

  const toggleInfoModal = () => {
    setInfoModalActive((isActive) => !isActive);
  };

  const toggleProductModal = () => {
    setProductModalActive((isActive) => !isActive);
  };

  //might be able to roll this into a custom hook
  const hasInventory = (product_type, required_qty) => {
    if (productStats) {
      try {
        return productStats.available >= required_qty;
      } catch (e) {
        console.warn(
          `Unable to determine if "${product_type}" has inventory. Assuming not.`
        );
        return false;
      }
    }
  };

  const checkIfAddrWhitelisted = (addr) => {
    setReservationStatus(null);

    try {
      wlsAx
        .get(`/whitelist/${APP_DATA.whitelistId}/address/${addr}/check`)
        .then((res) => {
          console.log(res);

          if (res.data && res.data.status === "eligible")
            setReservationStatus("CAPTCHA");
          else setReservationStatus("ADDR_NOT_ALLOWED");
        })
        .catch((error) => {
          console.error(error);
          setReservationStatus("SERVER_ERROR");
          return;
        });
    } catch (error) {
      console.error(error);
      setReservationStatus("SERVER_ERROR");
      return;
    }
  };

  const images = [
    "/badassMoose.jpg",
    "/badassBeaver.jpg",
    "/badassWolf.jpg",
    "/BadassWolf2.jpg",
  ];

  return (
    <>
      <Navbar
        showBuyButton={false}
        menuLocation="start"
        logoText=""
        contentViewportConstraint="fluid"
      />

      <Hero
        {...HERO_DATA}
        handleLaunchTimerExpiry={() => setHasLaunched(true)}
        hasLaunched={hasLaunched}
      />

      <div id="panel-section" className="section container is-fluid pb-6">
        <div className="content">
          <div className="columns">
            <div className="column">
              <Gallery
                images={images}
                imgMaxHeight="300px"
                mImgMaxHeight="250px"
                overflowY="hidden"
                galleryHeight="340px"
                imgMargin="20px"
                mImgMargin="10px"
              />
            </div>
          </div>
          <div className={`columns is-multiline is-centered`}>
            {products.map((product) => (
              <ProductPanel
                hasLaunched={hasLaunched}
                key={product.id}
                product={product}
                productStats={productStats}
                checkHumanity={checkHumanity}
                toggleProductModal={toggleProductModal}
                toggleInfoModal={toggleInfoModal}
                hasInventory={hasInventory}
                layout="Rich"
              />
            ))}
          </div>
        </div>
      </div>
      {productModalActive && activeProduct && (
        <ProductModal
          isActive={productModalActive}
          reservedTimer={reservedTimer}
          queueTimer={queueTimer}
          toggle={toggleProductModal}
          product={activeProduct}
          status={reservationStatus}
          reserveProduct={reserveProduct}
          setCaptchaUserResponseToken={setCaptchaUserResponseToken}
          expireReservation={expireReservation}
          checkIfAddrWhitelisted={checkIfAddrWhitelisted}
        />
      )}
      {infoModalActive && (
        <InfoModal isActive={infoModalActive} toggle={toggleInfoModal} />
      )}
      <Footer
        handleDebugClick={() => checkHumanity(activeProduct)}
        policyId={APP_DATA.policyId}
      />
    </>
  );
}

export default App;
